import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Link3 icon
 *
 * @category Files/Forms/Editing
 */
const Link3 = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M10.872 29C2.048 28.766.295 16.25 8.476 13.42c2.396-.654 2.396.457.246 1.193-7.247 2.723-4.757 13.92 2.956 13.113 6.884-.993 6.078-7.807 6.101-13.043.094-1.215.865-1.52 1.099-.187.362 6.428.42 13.861-7.784 14.504z"
        />
        <path
          fill="currentColor"
          d="M21.543 18.622c-.27-.27.479-.76 1.449-1.157 9.525-3.822 2.512-17.683-6.09-11.84-2.255 1.718-2.804 4.395-2.734 7.188-.175 1.052.538 6.019-.783 5.481-.608-.69-.34-2.092-.398-3.19-.327-4.628.433-10.051 5.435-11.652 6.451-2.338 12.587 4.861 9.595 10.974-.946 2.244-4.079 4.885-6.404 4.254l-.059-.058z"
        />
      </svg>
    );
  }
);

Link3.displayName = 'Link3';

export { Link3 };
